import { animateScroll as scroll } from "react-scroll";
import Button from "app/components/UI/Button";
import Flex from "app/components/UI/Flex";
import ImmutablePropTypes from "react-immutable-proptypes";
import PropTypes from "prop-types";
import React from "react";
import SelectableList from "app/components/UI/SelectableList";
import classes from "./AccountList.module.css";
import isMobileWitdh from "app/helpers/isMobile";

export const AccountList = ({ translate, contacts, onSelect, selectedContact, onNotFound }) => (
  <div className={classes.accountListContainer}>
    <div className={classes.accountList__table}>
      <div className={classes.accountList__table__header}>
        {translate("Le nom et le prénom correspondent à ces profils, veuillez sélectionner le votre :")}
      </div>
      <div className={classes.accountList__table__content}>
        <SelectableList>
          {contacts.slice(0, 3).map(contact => (
            <SelectableList.Item
              isSelected={selectedContact.get("contactId") === contact.get("contactId")}
              key={contact.get("contactId")}
              title={[contact.get("givenName"), contact.get("familyName")].join(" ")}
              subtitle={`Carte(s): ${contact
                .get("identificatorNumbers")
                .join(", ")
                .replace(/00000000/g, "")} ${contact.get("email") ? "- Email: " + contact.get("email") : ""}`}
              onClick={() => {
                onSelect(contact);
                isMobileWitdh && scroll.scrollToBottom();
              }}
            />
          ))}
        </SelectableList>
        <Flex direction="row" space="around">
          <Button
            className={classes.accountList__action}
            onClick={onNotFound}
            label={translate("Je ne trouve pas mon profil")}
          />
        </Flex>
      </div>
    </div>
  </div>
);

AccountList.propTypes = {
  translate: PropTypes.func.isRequired,
  contacts: ImmutablePropTypes.listOf(ImmutablePropTypes.map).isRequired,
  selectedContact: ImmutablePropTypes.map.isRequired,
  onSelect: PropTypes.func.isRequired,
  onNotFound: PropTypes.func.isRequired
};

export default AccountList;



// WEBPACK FOOTER //
// ./src/app/components/CheckoutAccount/AccountList/AccountList.js